import AlertsDrawer from './AlertsDrawer';

export default AlertsDrawer;
